<template>
  <div class="sendPoints">
    <img src="./1-1.png" class="logo" alt="" />
    <div class="qr">
      <div>立即下载东航期货APP开户</div>
      <div>参赛后，领取很多积分奖励</div>
      <img src="./qr.png" class="qrcode" alt="" />
      <div>APP首页点击“<span class="color">蓝海密剑</span>”板块</div>
      <div>选择“<span class="color">报名参赛</span>”即可获取积分</div>
    </div>
    <img src="./1-2.png" class="end" alt="" />
  </div>
</template>


<script>
/* eslint-disable */
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.sendPoints {
  background: url('./successbg.png') no-repeat;
  width: 100%;
  height: 100%;
  overflow: auto;
  text-align: center;
  background-size: 100% 100%;
}

.logo {
  margin-top: 20px;
  width: 100%;
  height: 200px;
}
.qr {
  width: 90%;
  margin: 0 auto;
  height: 480px;
  background: url('./qrbg.png') no-repeat;
  background-size: 100% 100%;
  padding: 30px 10px;
  line-height: 43px;
  letter-spacing: 3px;
  color: #26070a;
  font-size: 20px;
}

.qrcode {
  width: 200px;
  height: 200px;
  margin: 10px;
}

.end {
  width: 200px;
  height: 150px;
  margin: 20px 0px;
}

.color {
  color: #ff5937;
  font-weight: 600;
  padding-left: 8px;
}
</style>


// WEBPACK FOOTER //
// success.vue?4d34e2d1